// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5d801c15","977":"de8b593a"}[chunkId] + ".chunk.js";
};